import React from 'react';
import { Bed, Coffee, Store, Building2 } from 'lucide-react';
import { businesses } from '../mockData';

const iconMap = {
  Bed: Bed,
  Coffee: Coffee,
  Store: Store,
  Building2: Building2
};

const WhoWeHelp = () => {
  return (
    <section id="who-we-help" className="py-24 bg-gradient-to-b from-white to-emerald-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Who We Help
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Supporting the businesses that make South Devon special
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {businesses.map((business) => {
            const IconComponent = iconMap[business.icon];
            return (
              <div
                key={business.id}
                className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-emerald-200 hover:-translate-y-2"
              >
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-emerald-100 to-teal-100 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <IconComponent className="text-emerald-600" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {business.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {business.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhoWeHelp;